import { render, staticRenderFns } from "./manureLeft2.vue?vue&type=template&id=64ded0c7&scoped=true&"
import script from "./manureLeft2.vue?vue&type=script&lang=js&"
export * from "./manureLeft2.vue?vue&type=script&lang=js&"
import style0 from "./manureLeft2.vue?vue&type=style&index=0&id=64ded0c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ded0c7",
  null
  
)

export default component.exports